var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffingRadarOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.357 12.235A3.656 3.656 0 0111.15 8.45v1.63a2.1 2.1 0 101.7 0V4a.6.6 0 00-.6-.6h-.121c-4.717 0-8.656 3.746-8.728 8.466C3.328 16.67 7.213 20.6 12 20.6c4.46 0 8.138-3.413 8.56-7.764a.852.852 0 00-.847-.936.852.852 0 00-.846.773 6.908 6.908 0 01-7.426 6.205c-3.288-.26-5.963-2.864-6.303-6.145-.398-3.838 2.373-7.132 6.012-7.58v1.564a5.357 5.357 0 00-4.485 5.694 5.365 5.365 0 004.924 4.924 5.358 5.358 0 005.69-4.46.847.847 0 00-.842-.975.85.85 0 00-.838.708 3.656 3.656 0 01-3.834 3.035 3.67 3.67 0 01-3.408-3.408z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 8.6a2.1 2.1 0 100-4.2 2.1 2.1 0 000 4.2z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffingRadarOutline);
export default __webpack_public_path__ + "af8832f46d090c3b577727a04299077f.svg";
export { ForwardRef as ReactComponent };